<label class="checkbox" [ngClass]="alignment">
  <ng-content />
  <input type="checkbox" required (change)="toggle()" [checked]="isChecked" />
  <span class="checkmark" [ngClass]="style"></span>
</label>
